module.exports = __webpack_public_path__ + "img/whirlpool.bbf3de0a.svg";